import React from "react";
import Navbar from "../../Navigationbar/Navbar";
import { Outlet } from "react-router-dom";

const DefaultLayout = () => {
  return (
    <>
      <div className="">
        <div className="relative flex flex-col h-screen overflow-hidden">
          <Navbar />
          <main className="h-full overflow-hidden">
            <div className="w-full h-full overflow-y-auto overflow-x-hidden">
              <Outlet/>
            </div>
          </main>
        </div>
      </div>
    </>
  );
};

export default DefaultLayout;
